import { Badge, Box, Flex, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { colors } from '../../../../constants/colors';
import { CaseProgressDetail } from '../../hooks/useGetCaseProgressDetail';

interface Props {
  detail: CaseProgressDetail;
}

const VALUE_LABEL: Record<string, string> = {
  OK: 'OK / Surgery',
  ICU: 'ICU',
  NORA: 'NORA',
  PACU: 'PACU',
  RESUS: 'Resusitasi',
  PAIN_SERVICE: 'Manajemen Nyeri',
  PROCEDURE_CONSULTATION: 'Konsul Prosedur',
  POLI_PERIOPERATIVE: 'Poli Perioperatif',
  ELECTIVE: 'Elektif',
  EMERGENCY: 'Darurat',
  GERIATRIC: 'Geriatric',
};

const HeaderElement = ({ detail }: Props) => {
  const { element, description, criteria, accomplishedItems, caseCount } =
    detail;

  return (
    <Box
      border="1px solid"
      borderColor="gray.200"
      borderRadius="12px"
      padding="14px 16px"
      background="white"
    >
      <Flex align="baseline" gap="8px">
        <Text fontSize="20px" fontWeight="bold" color={colors.primaryPurple}>
          {element.id}
        </Text>
        <Text fontSize="16px" fontWeight="semibold">
          {element.elementName}
        </Text>
      </Flex>

      <Text fontSize="14px" color="gray.700" marginTop="6px">
        {description}
      </Text>

      <Flex gap="16px" marginTop="10px" fontSize="13px" wrap="wrap">
        <Text>
          <b>Tercapai:</b> {accomplishedItems} tindakan · {caseCount} kasus
        </Text>
        <Text>
          <b>Target Kolegium:</b> {element.targetKolegium}
        </Text>
        <Text>
          <b>Target Prodi:</b> {element.targetProdi}
        </Text>
      </Flex>

      <Box marginTop="12px">
        <Text fontSize="13px" fontWeight="bold" marginBottom="4px">
          Apa yang dihitung
        </Text>
        <Flex direction="column" gap="8px">
          {criteria.map((c, idx) => (
            <Box key={idx} fontSize="13px">
              <Text color="gray.700">{c.label}</Text>
              {c.values.length > 0 && (
                <Wrap marginTop="4px" spacing="6px">
                  {c.values.map((v) => (
                    <WrapItem key={v}>
                      <Badge colorScheme="purple" textTransform="none">
                        {VALUE_LABEL[v] ?? v}
                      </Badge>
                    </WrapItem>
                  ))}
                </Wrap>
              )}
              {c.items.length > 0 && (
                <Wrap marginTop="4px" spacing="6px">
                  {c.items.map((it) => (
                    <WrapItem key={it.id}>
                      <Badge
                        colorScheme={it.active ? 'gray' : 'red'}
                        variant="subtle"
                        textTransform="none"
                        fontWeight="normal"
                        padding="2px 6px"
                        whiteSpace="normal"
                        title={it.id}
                      >
                        {it.name}
                        {it.groupName ? ` (${it.groupName})` : ''}
                        <Text as="span" color="gray.500">
                          {' '}
                          · {it.shortId}
                        </Text>
                        {!it.active && <b> · nonaktif</b>}
                      </Badge>
                    </WrapItem>
                  ))}
                </Wrap>
              )}
            </Box>
          ))}
        </Flex>
        <Text fontSize="11px" color="gray.500" marginTop="8px">
          "nonaktif" = tipe/tag sudah tidak bisa dipilih di form, tetapi kasus
          lama yang memakainya tetap dihitung. Satu kasus bisa terhitung lebih
          dari satu tindakan.
        </Text>
      </Box>
    </Box>
  );
};

export default HeaderElement;
